module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('community-permissions-table', {
    attrs: {
      "communityPermissions": _vm.communityPermissions
    }
  }), _vm._v(" "), _c('nav', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.communityPermissionsPageCount > 1),
      expression: "communityPermissionsPageCount > 1"
    }]
  }, [_c('paginate', {
    ref: "communityPermissionsPaginate",
    attrs: {
      "pageCount": _vm.communityPermissionsPageCount,
      "clickHandler": _vm.paginateCommunityPermissions,
      "container-class": 'pagination justify-content-center',
      "page-class": 'page-item',
      "page-link-class": 'page-link',
      "prev-class": 'page-item',
      "prev-link-class": 'page-link',
      "next-class": 'page-item',
      "next-link-class": 'page-link'
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [_c('b-btn', {
    attrs: {
      "variant": "secondary"
    },
    on: {
      "click": _vm.refreshCommunityPermissions
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.refresh')) + "\n    ")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2189cce7"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/communities/CommunityPermissions.vue
// module id = 487
// module chunks = 0